export const actionTypes = {
    SET_VISITOR_PROFILE_DATA: 'SET_VISITOR_PROFILE_DATA',
    SET_VISITOR_PROFILE_CANCEL_TOKEN: 'SET_VISITOR_PROFILE_CANCEL_TOKEN',
    IS_VISITOR_PROFILE_FETCHING: 'IS_VISITOR_PROFILE_FETCHING'   
}